import { render, staticRenderFns } from "./DataAnalysis.vue?vue&type=template&id=2e287a02&scoped=true&"
import script from "./DataAnalysis.vue?vue&type=script&lang=js&"
export * from "./DataAnalysis.vue?vue&type=script&lang=js&"
import style1 from "./DataAnalysis.vue?vue&type=style&index=1&id=2e287a02&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e287a02",
  null
  
)

export default component.exports